// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginSubmitButton_root__2eZgI","label":"LoginSubmitButton_label__1exSA"};